import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ReturnNoteDialogOptions } from "./returnnote-dialog";
import { ReturnNoteDialogComponent } from "./returnnote-dialog.component";


@Injectable()
export class ReturnNoteDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Return Note Dialog Service Call

    Open(options?: ReturnNoteDialogOptions): Observable<string> {
        const self = this;

        const openHandle = self.matDialog.open<ReturnNoteDialogComponent>(ReturnNoteDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Confirmation Requested',
                MessageText: '',
                ReturnNote: '',
                ...options,
            },
            panelClass: 'returnNoteDialog',
            width: '1000px',
            minWidth: '1000px',
            maxWidth: '1000px',
            height: '40rem',
            minHeight: '40rem',
            maxHeight: '40rem',
        });

        return openHandle.afterClosed();
    }
}